module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageLoaded),
      expression: "pageLoaded"
    }]
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": _vm.member.info.headimgurl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("ID: " + _vm._s(_vm.member.info.id))]), _vm._v(" "), _c('div', [_vm._v("昵称: " + _vm._s(_vm.member.info.nick_name))])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "此代理库存库存"
    }
  }, _vm._l((_vm.child), function(x) {
    return _c('cell', {
      key: x.product_cate_id,
      attrs: {
        "title": x.cate_title,
        "value": x.amount,
        "is-link": true
      },
      nativeOn: {
        "click": function($event) {
          _vm.jump(x.product_cate_id)
        }
      }
    })
  })), _vm._v(" "), _c('group', {
    attrs: {
      "title": "您的库存"
    }
  }, _vm._l((_vm.self), function(x) {
    return _c('cell', {
      key: x.product_cate_id,
      attrs: {
        "title": x.cate_title,
        "value": x.amount + ' 点击转库存',
        "is-link": true
      },
      nativeOn: {
        "click": function($event) {
          _vm.transfer(x.product_cate_id)
        }
      }
    })
  })), _vm._v(" "), _c('group', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.transfer(6)
      }
    }
  }, [_vm._v("+ 护眼水 转库存")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.reduce(6)
      }
    }
  }, [_vm._v("- 护眼水 减库存")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "BACK"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('popup', {
    model: {
      value: (_vm.showTransfer),
      callback: function($$v) {
        _vm.showTransfer = $$v
      },
      expression: "showTransfer"
    }
  }, [_c('div', {
    staticClass: "popup0"
  }, [_c('group', {
    attrs: {
      "title": "请填写您要转移给该用户的数量"
    }
  }, [_c('x-input', {
    staticClass: "inputBox",
    attrs: {
      "min": 1,
      "max": _vm.maxQuantity,
      "title": "数量",
      "placeholder": "请输入要填写的库存",
      "type": "number"
    },
    model: {
      value: (_vm.inputQuantity),
      callback: function($$v) {
        _vm.inputQuantity = $$v
      },
      expression: "inputQuantity"
    }
  }), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitTransfer($event)
      }
    }
  }, [_vm._v("转移库存")])], 1)], 1)]), _vm._v(" "), _c('popup', {
    model: {
      value: (_vm.showGet),
      callback: function($$v) {
        _vm.showGet = $$v
      },
      expression: "showGet"
    }
  }, [_c('div', {
    staticClass: "popup0"
  }, [_c('group', {
    attrs: {
      "title": "请输入提货的数量"
    }
  }, [_c('x-input', {
    staticClass: "inputBox",
    attrs: {
      "min": 1,
      "max": _vm.maxReduceQuantity,
      "title": "数量",
      "placeholder": "请填写整数",
      "type": "number"
    },
    model: {
      value: (_vm.inputReduceQuantity),
      callback: function($$v) {
        _vm.inputReduceQuantity = $$v
      },
      expression: "inputReduceQuantity"
    }
  }), _vm._v(" "), _c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitReduce($event)
      }
    }
  }, [_vm._v("减少库存")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41120365"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/TransferStock.vue
// module id = 674
// module chunks = 0